import { useContext, useMemo, type CSSProperties } from "react";
import { WIDGET_TYPE } from "../../../types/widgets";
import { WidgetsConfigurations } from "../../../helpers/widgetsConfiguration";
import UnknownWidget from "../../widgets/unknownWidget";
import { WidgetContext } from "../../widgetContext";

interface ISelectWidgetProps {
  widgetType: WIDGET_TYPE;
}

// Wrapping element uses `display: contents` so it doesn't introduce a layout
// box — children behave as direct children of the parent grid/flex container.
// Playwright queries can still select on the data-* attributes via DOM lookup.
const wrapperStyle: CSSProperties = { display: "contents" };

const SelectWidget = ({ widgetType }: ISelectWidgetProps) => {
  const { widgetData, widgetLoading } = useContext(WidgetContext);

  const entityId = widgetData?.entity_id;

  const dataAttrs = useMemo(
    () => ({
      "data-entity-id": entityId,
      "data-widget-type": widgetType,
      "data-loading": widgetLoading ? "true" : "false",
    }),
    [entityId, widgetType, widgetLoading]
  );

  if (!(widgetType in WidgetsConfigurations)) {
    return (
      <div {...dataAttrs} style={wrapperStyle}>
        <UnknownWidget type={widgetType} />
      </div>
    );
  }

  const WidgetComponent = WidgetsConfigurations[widgetType].component;
  return (
    <div {...dataAttrs} style={wrapperStyle}>
      <WidgetComponent />
    </div>
  );
};

export default SelectWidget;
